import z from "zod";
import { LondonCareRecordConfigIdSchema } from "./londonCareRecord/londonCareRecordInstance.js";
export const CreateTrustOidRequestSchema = z.object({
    oid: z.string().min(1, "OID is required"),
    lcrInstanceId: LondonCareRecordConfigIdSchema.nullable(),
});
export const UpdateTrustOidRequestSchema = CreateTrustOidRequestSchema;
//# sourceMappingURL=trustOidRequests.js.map